// Module
var code = "<customer-users customer-id=\"vm.originalCustomer.id\"></customer-users>\n";
// Exports
module.exports = code;